//layout components
import Host from './components/layouts/Host.vue';
import Auth from './components/layouts/Auth.vue';

//
import Dashboard from './components/Dashboard.vue';
//import RegisterEmail from './components/RegisterEmail.vue';
//import RegisterInformation from './components/RegisterInformation.vue';
//import Login from './components/Login.vue';
//import EmailVerification from './components/EmailVerification.vue';
//import ForgotPassword from './components/ForgotPassword.vue';
//import ResetPassword from './components/ResetPassword.vue';
import Calendar from './components/calendar/Calendar.vue';
import Property from './components/Property.vue';
import Bookings from './components/bookings/Bookings.vue';
import Guestbook from './components/guestbook/Guestbook.vue';
import GuestbookReport from './components/report/GuestbookReport.vue';

import Room from './components/Room.vue';
import Booking from './components/booking/CreateBooking.vue';
import Reports from './components/reports/Reports.vue';
import Report from './components/report/CreateReport.vue';

//auth components
import Login from './components/auth/Login.vue';
import RegisterEmail from './components/auth/RegisterEmail.vue';
import EmailVerification from './components/auth/EmailVerification.vue';
import RegisterInformation from './components/auth/RegisterInformation.vue';
import ForgotPassword from './components/auth/ForgotPassword.vue';
import ResetPassword from './components/auth/ResetPassword.vue';

import BookingsList from './components/bookings/components/List';
import GuestList from './components/guestbook/components/List';
import ReportsList from './components/reports/components/List';

import Settings from './components/settings/Settings.vue';
import Profile from './components/settings/components/Profile.vue';

import Guest from './components/guests/CreateGuest';

import Rooms from './components/rooms/Rooms';
import RoomsList from './components/rooms/components/List';

import CashRegister from './components/cashRegister/CashRegister';
import Premise from './components/cashRegister/premises/Premise';
import Device from './components/cashRegister/devices/Device';
import Cachier from './components/cashRegister/cachiers/Cachier';

import Prices from './components/prices/Prices';
import PriceList from './components/prices/components/List';

import Price from './components/price/CreatePrice';

import Invoice from './components/invoice/CreateInvoice.vue';
import InvoicePDF from './components/invoices/PDF';

import Invoices from './components/invoices/Invoices';
import InvoiceList from './components/invoices/components/List';

import PaymentMethods from './components/paymentMethods/PaymentMethods';
import PaymentMethodList from './components/paymentMethods/components/List';
import PaymentMethod from './components/paymentMethod/CreatePaymentMethod';

import TouristTax from './components/touristTax/TouristTax';
import InvoiceReport from './components/invoices/Reports';

import CreateProperty from './components/property/Create';
import CreateRoom from './components/room/Create';
import PropertyList from './components/property/List';
import RoomList from './components/room/List';
import Blagajna from './components/property/Blagajna';

const routes = [
  /*
   *
   * PUBLIC ROUTES
   *
   */

  //authentication routes
  {
    path: '/register', component: Auth,
    children: [
      { path: '/login', component: Login, name: 'login'},
      { path: 'email', component: RegisterEmail, name: 'registerEmail' },
      { path: 'verifications/:verificationId', component: EmailVerification, name: 'registerVerification' },
      { path: 'tokens/:tokenId', component: RegisterInformation, name: 'registerToken' },
      { path: '/password/email', component: ForgotPassword, name: 'passwordEmail'},
      { path: '/password/email/:verificationId', component: EmailVerification, name: 'passwordVerification'},
      { path: '/password/reset/:tokenId', component: ResetPassword, name: 'passwordToken'},
    ]

  },
  //{ path: '/login', component: Login, name: 'login' },
  //{ path: '/register/email', component: RegisterEmail, name: 'registerEmail' },
  //{ path: '/register/verifications/:verificationId', component: EmailVerification, name: 'registerVerification' },
  //{ path: '/register/tokens/:tokenId', component: RegisterInformation, name: 'registerToken' },
  //{ path: '/password/email', component: ForgotPassword, name: 'passwordEmail'},
  //{ path: '/password/email/:verificationId', component: EmailVerification, name: 'passwordVerification'},
  //{ path: '/password/reset/:tokenId', component: ResetPassword, name: 'passwordToken'},

  /*
   *
   * PROTECTED ROUTES
   *
   */

  {
    path: "/en",  component: Host,
    children: [
      { path: 'settings', component: Settings, name: 'enSettings' },
      { path: 'settings/profile', component: Profile, name: 'enProfile' },
      { path: 'settings/properties', component: PropertyList, name: 'enListProperties' },
      { path: 'settings/properties/create', component: CreateProperty, name: 'enCreateProperty' },
      { path: 'settings/properties/:property/edit', component: CreateProperty, name: 'enUpdateProperty' },

      { path: 'settings/:property/rooms', component: RoomList, name: 'enListRooms' },
      { path: 'settings/:property/rooms/create', component: CreateRoom, name: 'enCreateRoom' },
      { path: 'settings/rooms/:room', component: CreateRoom, name: 'enUpdateRoom' },

      { path: 'settings/cash-register', component: Blagajna, name: 'enBlagajna' },

      { path: 'settings/prices/:price', component: Price, name: 'enUpdatePrice'},
      { path: 'settings/payment-methods/:method', component: PaymentMethod, name: 'enUpdatePaymentMethod'},

      {
        path: 'settings/:property', component: PaymentMethods, name: 'enPaymentMethods',
        children: [
          {
            path: 'payment-methods', component: PaymentMethodList, name: 'enListPaymentMethods',
          }
        ]
      },
      {
        path: 'settings/:property/payment-methods/create', component: PaymentMethod, name: 'enCreatePaymentMethod'
      },

      {
        path: 'settings/:property', component: Prices, name: 'enPrices',
        children: [
          {
            path: 'prices', component: PriceList, name: 'enListPrices',
          }
        ]
      },
      {
        path: ':property/prices/create', component: Price, name: 'enCreatePrice'
      },

      { path: '', component: Dashboard, name: 'enDashboard' },
      { path: 'bookings/:bookingId', component: Booking, name: 'enShowBooking'},

      { path: 'bookings/:bookingId/guests/create', component: Guest, name: 'enCreateGuest'},
      { path: 'guests/:guestId', component: Guest, name: 'enShowGuest' },
      { path: ':property/calendar', component: Calendar, name: 'enCalendar', props: {loading: false} },
      { path: ':property/calendar/:year/:month', component: Calendar, name: 'enCalendar', props: {loading: false} },
      {
        path: 'properties/:property', component: Property, name: 'enProperty',
        children: [
          {
            path: '/locks/:room', component: Room, name: 'enRoom',
          }
        ]
      },
      {
        path: ':property/reports/units-sold/:year/:month', component: Report, name: 'enCreateReport'
      },
      {
        path: ':property/reports/number-of-guests/:year/:month', component: TouristTax, name: 'enTouristTax'
      },
      {
        path: ':property/reports/issued-invoices/:year/:month', component: InvoiceReport, name: 'enInvoiceReport'
      },
      {
        path: ':property/reports/deletion-report/:year', component: GuestbookReport, name: 'enGuestbookReport',
      },
      {
        path: ':property/bookings/create', component: Booking, name: 'enCreateBooking'
      },
      /*{
        path: '/:property/bookings/:bookingId', component: Booking, name: 'showBooking'
      },*/
      //{ path: '/bookings/:propertyId', component: Bookings, name: 'bookings' },
      {
        path: ':property', component: Bookings, name: 'enBookings',
        children: [
          {
            path: 'bookings/:room?', component: BookingsList, name: 'enBookingsList',
          }
        ]
      },
      {
        path: ':property', component: Guestbook, name: 'enGuestbook',
        children: [
          {
            path: 'guests', component: GuestList, name: 'enGuestList',
          },
        ]
      },
      {
        path: ':property', component: Rooms, name: 'enRooms',
        children: [
          {
            path: 'rooms/:room?', component: RoomsList, name: 'enRoomsList',
          }
        ]
      },

      {
        path: ':property', component: CashRegister, name: 'enCashRegister',
        children: [
          {
            path: 'invoices/premise', component: Premise, name: 'enPremise',
          },
          {
            path: 'invoices/device', component: Device, name: 'enDevice',
          },
          {
            path: 'invoices/cachier', component: Cachier, name: 'enCachier',
          }
        ]
      },


      {
        path: ':property', component: Invoices, name: 'enInvoices',
        children: [
          {
            path: 'invoices', component: InvoiceList, name: 'enInvoiceList',
          }
        ]
      },


      {
        path: ':property', component: Reports, name: 'enReports',
        children: [
          {
            path: 'reports', component: ReportsList, name: 'enReportsList',
          },
          {
            path: 'reports/:year/:month', component: ReportsList, name: 'enReportsList'
          },
        ]
      },
      /*{
        path: '/settings', component: Settings, name: 'enSettings', children: [
          {
            path: 'profile', component: Profile, name: 'enProfile'
          }
        ],
      },*/
      { path: 'bookings/:bookingId/invoice', component: Invoice, name: 'enCreateInvoice'},
      //{ path: '/invoices/:invoiceId', component: Invoice, name: 'showInvoice'},
    ]
  },
  {
    path: "/sl",  component: Host,
    children: [
      { path: 'nastavitve', component: Settings, name: 'slSettings' },
      { path: 'nastavitve/profil', component: Profile, name: 'slProfile' },
      { path: 'nastavitve/nastanitve', component: PropertyList, name: 'slListProperties' },
      { path: 'nastavitve/nastanitve/ustvari', component: CreateProperty, name: 'slCreateProperty' },
      { path: 'nastavitve/nastanitve/:property/uredi', component: CreateProperty, name: 'slUpdateProperty' },

      { path: 'nastavitve/sobe/:room', component: CreateRoom, name: 'slUpdateRoom' },

      { path: 'nastavitve/blagajna', component: Blagajna, name: 'slBlagajna' },


      { path: 'nastavitve/cene/:price', component: Price, name: 'slUpdatePrice'},
      { path: 'nastavitve/placilna-sredstva/:method', component: PaymentMethod, name: 'slUpdatePaymentMethod'},


      { path: 'nastavitve/:property/sobe', component: RoomList, name: 'slListRooms' },
      { path: 'nastavitve/:property/sobe/ustvari', component: CreateRoom, name: 'slCreateRoom' },
      {
        path: 'nastavitve/:property', component: PaymentMethods, name: 'slPaymentMethods',
        children: [
          {
            path: 'placnilna-sredstva', component: PaymentMethodList, name: 'slListPaymentMethods',
          }
        ]
      },
      {
        path: 'nastavitve/:property/placilna-sredstva/ustvari', component: PaymentMethod, name: 'slCreatePaymentMethod'
      },

      {
        path: 'nastavitve/:property', component: Prices, name: 'slPrices',
        children: [
          {
            path: 'cene', component: PriceList, name: 'slListPrices',
          }
        ]
      },
      {
        path: 'nastavitve/:property/cene/ustvari', component: Price, name: 'slCreatePrice'
      },


      { path: '', component: Dashboard, name: 'slDashboard' },
      { path: 'rezervacije/:bookingId', component: Booking, name: 'slShowBooking'},
      { path: 'rezervacije/:bookingId/gostje/ustvari', component: Guest, name: 'slCreateGuest'},
      { path: 'gostje/:guestId', component: Guest, name: 'slShowGuest' },
      { path: ':property/koledar', component: Calendar, name: 'slCalendar', props: {loading: false} },
      { path: ':property/koledar/:year/:month', component: Calendar, name: 'slCalendar', props: {loading: false} },
      /*{
        path: 'nastanitve/:property', component: Property, name: 'slProperty',
        children: [
          {
            path: 'sobe/:room', component: Room, name: 'slRoom',
          }
        ]
      },*/
      {
        path: ':property/porocila/prodane-enote/:year/:month', component: Report, name: 'slCreateReport'
      },
      {
        path: ':property/porocila/stevilo-gostov/:year/:month', component: TouristTax, name: 'slTouristTax'
      },
      {
        path: ':property/porocila/izdani-racuni/:year/:month', component: InvoiceReport, name: 'slInvoiceReport'
      },
      {
        path: ':property/porocila/porocila-o-izbrisu/:year', component: GuestbookReport, name: 'slGuestbookReport',
      },
      {
        path: ':property/rezervacije/ustvari', component: Booking, name: 'slCreateBooking'
      },
      /*{
        path: '/:property/bookings/:bookingId', component: Booking, name: 'showBooking'
      },*/
      //{ path: '/bookings/:propertyId', component: Bookings, name: 'bookings' },
      {
        path: ':property', component: Bookings, name: 'slBookings',
        children: [
          {
            path: 'rezervacije/:room?', component: BookingsList, name: 'slBookingsList',
          }
        ]
      },
      {
        path: ':property', component: Guestbook, name: 'slGuestbook',
        children: [
          {
            path: 'gostje', component: GuestList, name: 'slGuestList',
          }
        ]
      },
      {
        path: ':property', component: Rooms, name: 'slRooms',
        children: [
          {
            path: 'kljucavnice/:room?', component: RoomsList, name: 'slRoomsList',
          }
        ]
      },

      {
        path: ':property', component: CashRegister, name: 'slCashRegister',
        children: [
          {
            path: 'racuni/poslovni-prostor', component: Premise, name: 'slPremise',
          },
          {
            path: 'racuni/naprava', component: Device, name: 'slDevice',
          },
          {
            path: 'racuni/blagajnik', component: Cachier, name: 'slCachier',
          }
        ]
      },


      {
        path: ':property', component: Invoices, name: 'slInvoices',
        children: [
          {
            path: 'racuni', component: InvoiceList, name: 'slInvoiceList',
          }
        ]
      },


      {
        path: ':property', component: Reports, name: 'slReports',
        children: [
          {
            path: 'porocila', component: ReportsList, name: 'slReportsList',
          },
          {
            path: 'porocila/:year/:month', component: ReportsList, name: 'slReportsList'
          },
        ]
      },
      /*{
        path: 'nastavitve', component: Settings, name: 'slSettings', children: [
          {
            path: 'profil', component: Profile, name: 'slProfile'
          }
        ],
      },*/
      { path: 'rezervacije/:bookingId/racun', component: Invoice, name: 'slCreateInvoice'},
      //{ path: '/invoices/:invoiceId', component: Invoice, name: 'showInvoice'},
    ]
  },
  { path: '/en/invoices/invoiceId', component: InvoicePDF, name: 'enInvoicePdf'},
  { path: '/sl/racuni/:invoiceId', component: InvoicePDF, name: 'slInvoicePdf'},
];

export default routes;
